var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('notifications-wrapper',{attrs:{"position":"bottom right","width":"20%"}}),_vm._v(" "),_c('top-navbar'),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('custom-footer'),_vm._v(" "),_c('image-zoom-modal'),_vm._v(" "),_c('share-images-modal'),_vm._v(" "),_c('resource-notifications-create-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }